var createStylesheet = (fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	linkTag.onload = resolve;
	linkTag.onerror = function(event) {
		var request = event && event.target && event.target.src || fullhref;
		var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
		err.code = "CSS_CHUNK_LOAD_FAILED";
		err.request = request;
		linkTag.parentNode.removeChild(linkTag)
		reject(err);
	};
	linkTag.href = fullhref;

	(function(element) {
	    const rootId = 'chat-ui-shadow-root';
	    let root = document.getElementById(rootId);
	    // create shadowroot on demand if it doesn't exist yet
	    if (root === null) {
	        root = document.createElement('div');
	        root.setAttribute('id', rootId);
	        root.attachShadow({mode: 'open'});
	        document.body.appendChild(root);
	    }
	    const parent = root.shadowRoot;
	    parent.appendChild(element);
	})(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	179: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"949":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr